'use client';

import { type HTMLMotionProps, motion } from 'framer-motion';
import { ReactNode } from 'react';
import { cn } from '@/lib/ui-kit/utils';

interface AnimatedReactionButtonProps extends HTMLMotionProps<'button'> {
  children: ReactNode;
  isActive: boolean;
  tapScale?: number;
  bounceScale?: number;
  bounceDuration?: number;
}

export function AnimatedReactionButton({
  children,
  isActive,
  tapScale = 0.9,
  bounceScale = 1.3,
  bounceDuration = 0.3,
  className,
  ...props
}: AnimatedReactionButtonProps) {
  return (
    <motion.button
      whileTap={{ scale: tapScale }}
      animate={{
        scale: isActive ? [1, bounceScale, 1] : 1,
      }}
      transition={{
        duration: bounceDuration,
        ease: 'easeInOut',
      }}
      className={cn(className)}
      {...props}
    >
      {children}
    </motion.button>
  );
}
